@if (isLovDataLoaded) {
  <div
    class="table-view-table"
    [ngClass]="{ 'three-fixed-columns': showConfidentialityComponent }"
    >
    @if (allColumns?.length && reportRecordData?.length) {
      <p-table [columns]="allColumns" [value]="reportRecordData" [reorderableColumns]="true">
        <ng-template pTemplate="header" let-columns>
          <tr class="table-view-headers">
            <th>{{ actionHeader }}</th>
            <!-- Confidentiality header -->
            @if (showConfidentialityComponent) {
              <th class="confidentiality-header">
                {{ 'template.reportViewState' | translate | titlecase }}
              </th>
            }
            @for (col of columns; track col) {
              <th pReorderableColumn (dragend)="reorderColumns(columns)">
                {{ col.header | titlecase }}
              </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-recordCatalog let-columns="columns" let-i="rowIndex">
          <tr [pReorderableRow]="i" (dragstart)="dragStartColumn(i)" (dragend)="dropColumn(i)" draggable="true">
            <td class="sno">
              <i class="fa fa-arrows move-record" pReorderableRowHandle></i>
              <mat-icon
                class="green-close"
                color="y-icon"
                svgIcon="close-icon-grey"
                (click)="removeRecord.emit(recordCatalog)"
              ></mat-icon>
              <a [routerLink]="recordCatalog | dataViewRoute: reportData().entity" class="record-link" target="_blank">
                <mat-icon class="print-hidden" color="y-icon" svgIcon="open_in_browser"></mat-icon>
              </a>
            </td>
            <!-- Confidentiality component -->
            @if (showConfidentialityComponent) {
              <td>
                <div class="confidentiality-container">
                  <ng-container
                    [ngTemplateOutlet]="templateProjectionMap() | selectTemplateOutlet: 'miq-confidentiality-control-tmpl'"
                    [ngTemplateOutletContext]="{ reportItem: recordCatalog, displayLabel: true, isDataOnly: true }"
                  ></ng-container>
                </div>
              </td>
            }
            @for (col of columns; track col) {
              <td class="data-columns">
                <span
                  class="table-data-cells"
                  [ngClass]="{ clickable: col?.parent?.update }"
                  (click)="emitEditableFields($event, col, recordCatalog)"
                  >{{ recordCatalog | dataViewFormatter: col }}
                </span>
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <div class="no-records">{{ 'template.noData' | translate }}</div>
    }
  </div>
}
